// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","438":"2d36dd80","624":"fb7d5399","834":"component---src-pages-404-index-tsx"}[chunkId] + "-" + {"245":"88dec5a23abf92306ca8","438":"6240ac3ee7b2d250d0de","624":"1af351cb7c25aaf22579","834":"78547a548e3aef83bc2e"}[chunkId] + ".js";
};